import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'replaceStringWith',
})

export class ReplaceStringWithPipe implements PipeTransform {

    public transform(value: string): string {
        return value ? value.split(`-`).join(``) : value;
    }
}
